@if (user$ | async; as _user) {
  <div class="menu-item px-3">
    <div class="menu-content d-flex align-items-center px-3">
      <div class="symbol symbol-50px me-5">
        <img alt="Logo" src="./assets/media/logos/ECAM LOGO ONLY.svg" />
      </div>
      <div class="d-inline-block overflow-hidden white-space-nowrap text-truncate text-muted">
        <span class="fw-bolder text-dark d-flex align-items-center fs-5">
          <!-- User Name and Last Name-->
          {{_user.name}} {{_user.surname}}
        </span>
        <span class="fw-bold fs-7">
          <!-- User email -->
          {{_user.emailAddress}}
        </span>
      </div>
    </div>
  </div>
  @if (_user.isImpersonated) {
    <div class="separator my-2"></div>
    <div class="menu-item px-5">
      <div class="text-left">
        <a class="d-flex flex-row align-items-center menu-link px-5" (click)="unimpersonate()">
          <ng-container>
            <div class="m-2">
              <i class="bi bi-reply-fill text-primary"></i>
            </div>
          </ng-container>
          <ng-container>
            <span class="spinner spinner-primary spinner-track spinner-sm pr-7"></span>
          </ng-container>
          Back to my account
        </a>
      </div>
    </div>
  }
  <div class="separator my-2"></div>
  <div class="menu-item px-5" data-kt-menu-trigger="hover" data-kt-menu-placement="left-start"
    data-kt-menu-flip="bottom">
    <a class="menu-link px-5 cursor-pointer">
      <span class="menu-title position-relative">
        Language
        <span class="
            fs-8
            rounded
            bg-light
            px-3
            py-2
            position-absolute
            translate-middle-y
            top-50
            end-0
          ">
          {{ language.name }}{{ " " }}
          <img class="w-15px h-15px rounded-1 ms-2" [src]="language.flag" alt="stealth" />
        </span>
      </span>
    </a>
    <div class="menu-sub menu-sub-dropdown w-175px py-4">
      @for (l of langs; track l) {
        <div class="menu-item px-3 cursor-pointer" (click)="selectLanguage(l.lang)">
          <a class="menu-link d-flex px-5" [ngClass]="l.lang === language.lang ? 'active' : ''">
            <span class="symbol symbol-20px me-4">
              <img class="rounded-1" [src]="l.flag" alt="stealth" />
            </span>
            {{ l.name }}
          </a>
        </div>
      }
    </div>
  </div>
  <div class="menu-item px-5">
    <a (click)="logout()" class="menu-link px-5 cursor-pointer"> Sign Out </a>
  </div>
}
